module.exports = __webpack_public_path__ + "img/PRAlfaCFLogo - Lite.b8683ee2.png";